(function() {
    function DateDiff(date1, date2) {
        this.days = null;
        this.hours = null;
        this.minutes = null;
        this.seconds = null;
        this.date1 = date1;
        this.date2 = date2;

        this.init();
    }

    DateDiff.prototype.init = function() {
        var data = new DateMeasure(this.date1 - this.date2);
        this.days = data.days;
        this.hours = data.hours;
        this.minutes = data.minutes;
        this.seconds = data.seconds;
    };

    function DateMeasure(ms) {
        var d, h, m, s;
        s = Math.floor(ms / 1000);
        m = Math.floor(s / 60);
        s = s % 60;
        h = Math.floor(m / 60);
        m = m % 60;
        d = Math.floor(h / 24);
        h = h % 24;

        this.days = d;
        this.hours = h;
        this.minutes = m;
        this.seconds = s;
    };

    Date.diff = function(date1, date2) {
        return new DateDiff(date1, date2);
    };

    Date.prototype.diff = function(date2) {
        return new DateDiff(this, date2);
    };
})();


function convertTimer (timer) {
    var diff;
    var date;
    var text;
    var format;
    var now = new Date();
    var localTime = now.getTime();
    var localOffset = now.getTimezoneOffset() * 60000;
    var utc = localTime + localOffset;
    var configuration =
        {
            'days':
                {
                    '[D]': ' Day{s}',
                    '[d]': ' day{s}',
                    '[dx]': 'd',
                },
            'hours':
                {
                    '[H]': ' Hour{s}',
                    '[h]': ' hour{s}',
                    '[hx]': 'h',
                },
            'minutes':
                {
                    '[M]': ' Minute{s}',
                    '[m]': ' minute{s}',
                    '[min]': ' min',
                    '[Min]': ' Min',
                    '[mx]': 'm',
                },
            'seconds':
                {
                    '[S]': ' Second{s}',
                    '[s]': ' second{s}',
                    '[sec]': ' sec',
                    '[Sec]': ' Sec',
                    '[sx]': 's'
                }
        };

    now = new Date(utc);

    text = timer.data('text');
    var arr = timer.data('date').split(/[- :]/),
    date = new Date(arr[0], arr[1]-1, arr[2], arr[3], arr[4], arr[5]);
    
    if (typeof timer.attr('data-format') !== typeof undefined) {
        format = timer.attr('data-format');
    } else {
        format = timer.html();
        timer.attr('data-format', format);
    }
    
    diff = date.diff(now);

    
    if (diff.days <= 0 && diff.hours <= 0 && diff.minutes <= 0 && diff.seconds <= 0) {
        timer.removeClass('hide');
        timer.html(text);
        return;
    }

    if (diff.days == 1 && diff.hours == 0) {
        diff.days = 0;
        diff.hours += 24;
    }

    if (diff.hours == 1 && diff.minutes == 0) {
        diff.hours = 0;
        diff.minutes += 60;
    }

    var text = format;

    //Remove days keys
    for (var type in configuration) {
        for (var tag in configuration[type]) {
            if (type === 'days' && diff.days == 0) {
                text = text.replace(tag + ' ', '').replace(tag, '');
            }
            else if (type === 'hours' && (diff.days >= 0 && diff.hours == 0)) {
                text = text.replace(tag + ' ', '').replace(tag, '');
            }
            else if (type === 'minutes' && ((diff.hours >= 0 && diff.minutes == 0) || diff.days > 0)) {
                text = text.replace(tag + ' ', '').replace(tag, '');
            }
            else if (type === 'seconds' && ((diff.days > 0) || (diff.days >= 0 && diff.hours > 0))) {
                text = text.replace(tag + ' ', '').replace(tag, '');
            }
        }
    }

    //Insert values
    for (var type in configuration) {
        for (var tag in configuration[type]) {
            if (text.indexOf(tag) !== -1) {
                var value = '';
                if (diff[type] > 1) {
                    value = configuration[type][tag].replace('{s}', 's');
                }
                else {
                    value = configuration[type][tag].replace('{s}', '');
                }

                text = text.replace('<b>'+tag+'</b>', diff[type] + value);
                text = text.replace(tag, diff[type] + value);
            }
        }
    }

    timer.html(text);
    timer.removeClass('hide');

    setTimeout(function () {
        convertTimer(timer);
    }, 1000);
};

function convertTimers () {
    var timers = $('[data-timer="true"]');

    timers.each(function () {
        try {
            convertTimer($(this));
        } catch (Err) {
            console.log(Err);
        }
    });
};


$(function () {
    convertTimers();
});